import ContactsBaseDetailsPageController from './base';

export default class ContactsDetailsOverviewPageController extends ContactsBaseDetailsPageController {
    constructor($scope, $injector) {
        super($scope, $injector);

        this.workflows = this.injector.get('Workflows');
        this.acl = this.injector.get('Acl')

        this.showQuickRsvpList = !!_.get(this.injector.get('Users'), 'state.company.settings.contacts.show_oktoberfest_rsvp_list_in_details', false);
        this.consumptionsEnabled = !!_.get(this.injector.get('Users'), 'state.company.settings.contacts.enable_consumptions', false);
    }

    gotoContact(model) {
        const params = {
            id: this.store.state.slug === 'rsvps' ? model.contact.id : model.id,
            contact: this.store.state.slug === 'rsvps' ? model.contact : model,
            store: this.store,
            back: this.params.back,
            backParams: this.params.backParams,
        };
        return this.router.go('app.contacts.details.overview', params, {reload: true})
    }

    _updateToolbox() {
        const actions = _(this.workflows.getWorkflows('addressbook::details'))
            .filter(workflow => {
                return this.contact.archived ? workflow.level === 'archived-highlight' : workflow.level === 'highlight';
            })
            .map(workflow => {
                if (!workflow.onClick) {
                    workflow.onClick = workflow.action;
                }
                workflow.action = () => {
                    workflow.onClick(this.contact, this);
                };
                workflow.order = workflow.order || 30;
                return workflow;
            })
            .sortBy('order', 'asc')
            .value();

        this.navService.overrideMainSideNavActions(actions);
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/contacts/controllers/pages/details/overview.js